/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../error/error-name';

/**
 * Správce operační paměti pro standardní webové technologie.
 * @implements {MemoryManager}
 */
class WebMemoryManager {
  /** @inheritdoc */
  getInfo() {
    return new Promise(() => {
      const error = new Error('Unable to get memory info.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }
}

export default WebMemoryManager;
